import React, { useEffect, useState } from 'react';
import Isvg from 'react-inlinesvg';
import _ from 'lodash'
import Popover from "components/popover/popover";
import { WithTip } from 'components/tooltip/with-tip';
import { HeaderIcon_s, NotifContainer_s, Notif_s } from 'components/wrapper/header/header-styles';
import keyService, * as chord from "data/key";
import { CloseIcon } from "images/icons/general/";
import { Button_s } from "styles/app-styles"
import { BellExclamation, BellExclamationAlt } from 'images/icons/header';
import { ShortcutHint_s } from 'styles/shortcut-styles';
import NewNotificationIcon from "./new-notification-icon";
import notificationService from "data/notification";
import { NotificationQueueItem } from "data/interface/notification"

const NewNotifications = () => {
  const [showPopover, setShowPopover] = useState<boolean>(false)
  const [hintsVisible, setHintsVisible] = useState<boolean>(false)
  const [newNotifications, setNewNotifications] = useState<boolean>(false)
  const [notifications, setNotifications] = useState<NotificationQueueItem[]>([])

  useEffect(() => {
    keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_ALT_N && k.down === true:
          setShowPopover(!showPopover)
          break
        case k.chord === chord.CTRL_ALT && k.down === true:
          setHintsVisible(true)
          break
        case k.chord === chord.CTRL_ALT && k.down === false:
          setHintsVisible(false)
          break
      }
    })

    const notificationSubscription = notificationService.queueStream().subscribe(n => {
      if(n.length === 0) setNewNotifications(false)
      if(n.length > notifications.length) setNewNotifications(true)
      setNotifications(_.cloneDeep(n))
    })

    return () => {
      notificationSubscription.unsubscribe()
    }
  }, [showPopover, notifications])

  useEffect(() => {
    notificationService.fetchQueue()
  }, [])

  const longRunning = _.some(notifications, (notif) => notif.longRunning === true && !notif.completed)

  return (
    <HeaderIcon_s>
      <WithTip position="bottom">
        <span>Notifications</span>
        <a onClick={()=> {
          setShowPopover(!showPopover)
          setNewNotifications(false)
        }}>
          {longRunning ? <Isvg src={BellExclamationAlt} id="notifPopoverIcon" /> : <Isvg src={BellExclamation} id="notifPopoverIcon" />}
          { hintsVisible && <ShortcutHint_s className="header-hint" visible={hintsVisible}>N</ShortcutHint_s> }
          { newNotifications && <NewNotificationIcon /> }
        </a>
      </WithTip>
      <Popover
        show={showPopover}
        toggleShow={setShowPopover}
        position="top right"
        target='notifPopoverIcon'
        title="Notifications"
        width={400}
        headerButton={() => <Button_s className="depress" style={{height: '20px', marginLeft: '10px'}} onClick={()=>notificationService.dequeueAll()}>Clear All</Button_s>}
      >
        <NotifContainer_s>
          { notifications.length ?
              notifications.map(n => (
                <Notif_s key={n.correlationid} className={`notification-queue-item ${n.correlationid}`}>
                  <div>
                    {n.component ? <n.component correlationid={n.correlationid} key={n.correlationid} initialMessage={n.message} /> : n.message}
                  </div>
                  <div>
                    {n.timestamp}
                  </div>
                  <div>
                    <Isvg className="close-btn" src={CloseIcon} onClick={() => notificationService.dequeue(n.correlationid)}/>
                  </div>
                </Notif_s>
              ))
              :
              <div>No notifications</div>
          }
        </NotifContainer_s>
      </Popover>
    </HeaderIcon_s>
  )
}

export default NewNotifications;
